import React, { useEffect, useState } from 'react';
import { useGetBusinessBySubdomainQuery } from '../store';
import EventDTO, { EventPublicStatus } from '../models/event';
import AvailableEventsPage from './AvailableEventsPage';
import LoadingLottie from '../components/atoms/LoadingLottie';

interface Props {
  subdomain: string;
}

const BusinessLanding: React.FC<Props> = ({ subdomain }) => {
  const { data: business, isLoading } = useGetBusinessBySubdomainQuery(subdomain);
  const [activeEvents, setActiveEvents] = useState<EventDTO[]>([]);

  useEffect(() => {
    if (business) {
      setActiveEvents(business.events.filter((e) => e.public_status === EventPublicStatus.Ready));
    }
  }, [business]);

  if (isLoading) {
    return <LoadingLottie />;
  }

  if (!business && !isLoading) {
    return <div>Productora no encontrada</div>;
  }

  return (
    <div>
      {activeEvents.length >= 1 && <AvailableEventsPage loadedEvents={activeEvents} business={business || undefined} />}
      {activeEvents.length === 0 && <div className="min-h-screen flex items-center justify-center">Este organizador aún no tiene eventos publicados</div>}
    </div>
  );
};

export default BusinessLanding;
